import { useMutation } from 'react-query';
import { httpService } from '../../../../../../services/http.service';

import { BASE_URL } from '../../../../../../constants/endpoints';
import { IServerErrorResponse } from '../../../../../../types';
import { flattenServerErrorResponse } from '../../../../../../helpers/errors.helper';

interface IProps {
    phoneNumber: String;
}

export const useRecoverEmail = (onError: (msg: string) => void) => useMutation(
  'recoverEmail',
  async ({
    phoneNumber,
  }: IProps) => {
    const res = await httpService.post(`${BASE_URL}/api/v1/user/openauth/recovery/login`, { phoneNumber });
    return res.data;
  },
  {
    retry: 0,
    onError: (e:IServerErrorResponse) => {
      const { localizedMessage } = flattenServerErrorResponse(e);
      onError(localizedMessage);
    },
  },
);
